import { UserTier } from "@/enums/UserTier";

export const navigation = [
  {
    title: "Landing Page",
    icon: "icon-world.svg",
    link: "/v2/project-page",
    slug: "project-page",
    requiredTier: UserTier.TIER_1,
  },
  {
    title: "Lots",
    icon: "icon-lots-v2.svg",
    link: "/v2/lots",
    slug: "lots",
    requiredTier: UserTier.TIER_1,
  },
  {
    title: "Reports",
    icon: "icon-reports.svg",
    link: "/v2/reports",
    slug: "reports",
    requiredTier: UserTier.TIER_2,
  },
  {
    title: "Leads",
    icon: "icon-leads-v2.svg",
    link: "/v2/leads",
    slug: "leads",
    requiredTier: UserTier.TIER_1,
  },
];

export const homeAndLandPackagesNavigation = {
  title: "H&L Packages",
  icon: "icon-home.svg",
  link: "/v2/hl-packages",
  slug: "hl-packages",
  requiredTier: UserTier.TIER_1,
};

export const profilesNavigations = {
  landowner: [
    {
      title: "Account",
      icon: "icon-dashboard.svg",
      link: "/v2/profile/general",
      slug: "general",
      requiredTier: UserTier.TIER_1,
    },

    {
      title: "Projects",
      icon: "icon-lots.svg",
      link: "/v2/profile/estates",
      slug: "estates",
      requiredTier: UserTier.TIER_1,
    },

    {
      title: "Users",
      icon: "icon-sales-person.svg",
      link: "/v2/profile/users",
      slug: "users",
      requiredTier: UserTier.TIER_1,
    },

    {
      title: "Subscriptions",
      icon: "icon-subscription.svg",
      link: "/v2/profile/subscriptions-billing",
      slug: "subscriptions-billing",
      requiredTier: UserTier.TIER_1,
    },
  ],
  salesPerson: [
    {
      title: "Account",
      icon: "icon-dashboard.svg",
      link: "/v2/profile/general",
      slug: "general",
      requiredTier: UserTier.TIER_1,
    },

    {
      title: "Projects",
      icon: "icon-lots.svg",
      link: "/v2/profile/estates",
      slug: "estates",
      requiredTier: UserTier.TIER_1,
    },
  ],
};
